module.exports = __webpack_public_path__ + "static/media/elegant-dress.031bc4ff.jpg";